import { useEffect, useState } from 'react';
import { getAccess } from '../services/modelPortfolioApi';

// Whether this user can see Model Portfolios (owner-only until the server's
// MODEL_PORTFOLIOS_OPEN flag is set). One request per page load, shared by
// the nav, the drawer and the home card.
let pending = null;

export default function useModelAccess() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let hasToken = false;
    try { hasToken = !!localStorage.getItem('alphagrade_auth_token'); } catch { /* private mode */ }
    if (!hasToken) return undefined;
    if (!pending) {
      pending = getAccess()
        .then((d) => !!d?.enabled)
        .catch(() => {
          pending = null;
          return false;
        });
    }
    pending.then((v) => { if (!cancelled) setEnabled(v); });
    return () => { cancelled = true; };
  }, []);
  return enabled;
}
